var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"tw-object-contain tw-h-[48px] xl:tw-h-[80px] tw-w-full tw-mb-4",attrs:{"alt":"Uptogether","src":_vm.logoUrl}})
}
var staticRenderFns = []

export { render, staticRenderFns }